<template>
    <div class="footer-wrap">
        <div class="footer">
            <div class="title">Organization</div>
            <div class="logo-list">
                <div class="logo">
                    <div class="img"><img src="../assets/images/makex.png"></div>
                    <div class="type">Hosted by: </div>
                    <div class="name">MakeX Robotics Competition Committee</div>
                </div>
                <div class="logo">
                    <div class="img"><img src="../assets/images/makex.png"></div>
                    <div class="type">Organizer: </div>
                    <div class="name">Shenzhen Hulu Maker Co., Ltd.</div>
                </div>
                <div class="logo">
                    <div class="img"><img src="../assets/images/makeblock.png"></div>
                    <div class="type">Co-organizer: </div>
                    <div class="name">Shenzhen Makeblock Co., Ltd.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style lang="scss" scoped>
    .footer-wrap {
        background: #010519;
        padding: 75px 0 125px;
    }
    .footer {
        width: 1220px;
        margin: 0 auto;
        .title {
            font-size: 18px;
            color: #fff;
            line-height: 36px;
            border-bottom: 1px solid rgba(151, 151, 151, .4);
            margin-bottom: 45px;
        }
        .logo-list {
            display: flex;
            justify-content: space-between;
            .logo {
                text-align: center;
                color: #fff;
                .img {
                    height: 40px;
                }
                img {
                    margin-bottom: 15px;
                }
                .type {
                    margin-bottom: 5px;
                    font-weight: bold;
                }
            }
        }
    }
</style>
